export default __webpack_public_path__ + "static/media/detail_mobile_12_1.8a21eddf.jpg";